import React from 'react';
import { Box, Typography, FormControlLabel, Checkbox, FormControl, Select, MenuItem } from "@mui/material";
import { PokemonDefenceInterface, hasPokemonStatus, setPokemonStatus } from "../../pokemon/pokemon";
import { hasDefenceAbilityEffects, isMarvelScale, hasKodaiOrQuark } from "../../lib/ability";

interface AbilityEffectsComponentsProps {
  selectedPokemon: PokemonDefenceInterface;
  setSelectedPokemon: React.Dispatch<React.SetStateAction<PokemonDefenceInterface | null>>;
}

function AbilityEffectsComponents({
  selectedPokemon,
  setSelectedPokemon
}: AbilityEffectsComponentsProps) {
  // 特性による防御補正設定があるかどうかチェック
  const hasAbilityEffects = hasDefenceAbilityEffects(selectedPokemon);

  if (!hasAbilityEffects) {
    return null;
  }

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        その他
      </Typography>
      
      {/* ふしぎなうろこ特性用の状態異常チェック */}
      {isMarvelScale(selectedPokemon) && (
        <FormControlLabel
          control={
            <Checkbox
              checked={hasPokemonStatus(selectedPokemon?.other_setting, 'status-ailment')}
              onChange={(e) => {
                if (selectedPokemon) {
                  setSelectedPokemon({
                    ...selectedPokemon,
                    other_setting: setPokemonStatus(
                      selectedPokemon.other_setting,
                      'status-ailment',
                      e.target.checked,
                    ),
                  });
                }
              }}
              color="primary"
            />
          }
          label="状態異常"
          sx={{ 
            '& .MuiFormControlLabel-label': { 
              fontSize: '0.9rem' 
            },
            display: 'block'
          }}
        />
      )}

      {/* こだいかっせい・クォークチャージ特性用の選択 */}
      {hasKodaiOrQuark(selectedPokemon) && (
        <Box sx={{ mt: 1 }}>
          <Typography variant="body2" sx={{ mb: 1, fontSize: '0.9rem' }}>
            こだいかっせい/クォークチャージ
          </Typography>
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <Select
              value={selectedPokemon?.other_setting?.kodai_defense_stat || 'none'}
              onChange={(e) => {
                if (selectedPokemon) {
                  setSelectedPokemon({
                    ...selectedPokemon,
                    other_setting: {
                      ...selectedPokemon.other_setting,
                      kodai_defense_stat: e.target.value as 'none' | 'defense' | 'special_defense'
                    }
                  });
                }
              }}
              sx={{
                fontSize: '0.9rem',
                '& .MuiSelect-select': {
                  padding: '8px 12px'
                }
              }}
            >
              <MenuItem value="none" sx={{ fontSize: '0.9rem' }}>なし</MenuItem>
              <MenuItem value="defense" sx={{ fontSize: '0.9rem' }}>防御</MenuItem>
              <MenuItem value="special_defense" sx={{ fontSize: '0.9rem' }}>特防</MenuItem>
            </Select>
          </FormControl>
        </Box>
      )}
    </Box>
  );
}

export default AbilityEffectsComponents;
